function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import { withStyles } from '@material-ui/core/styles';

var DisplayComponent = function DisplayComponent(props) {
  var classes = props.classes,
      e2e = props['data-e2e'],
      id = props.id,
      style = props.style,
      value = props.value;
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: classes.root,
      "data-e2e": e2e,
      id: id,
      style: style
    }, value)
  );
};

var styles = function styles(theme) {
  return {
    root: _objectSpread(_objectSpread({}, theme.typography.body1), {}, {
      // TODO: remove next line once typography does not define color anymore (affects disabled TextField)
      color: 'inherit',
      width: '100%',
      padding: '0px 4px'
    })
  };
};

export var Display = withStyles(styles)(DisplayComponent);